import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
import { RootState } from '../../store/store.state';
import { selectUserAuth } from '../store/auth.store';

@Injectable()
export class InternalUserGuard implements CanActivate {
    protected framed: boolean = false;
    constructor(
        private store: Store<RootState>,
        private router: Router,
        private configManagerService: ConfigManagerService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.store.pipe(
            select(selectUserAuth),
            take(1),
            map(userAuth => {
                console.log('userAuth', userAuth);
                if (userAuth?.isInternal) {
                    return true;
                } else if (userAuth.claims) {
                    this.router.navigate(['/redirect-rd'], {
                        skipLocationChange: true
                    });
                    return false;
                } else {
                    // Lets auth valid guard handle auth redirects
                    return false;
                }
            })
        );
    }

    isUserAuthorized(enabledApps: string[]): boolean {
        return enabledApps.includes(this.configManagerService.ssoConfig.appKey);
    }

    isUserInternal(username: string): boolean {
        return (
            username.endsWith('@quotient.com') ||
            username.endsWith('@neptuneretailsolutions.com')
        );
    }
}
